import { useState, useRef, useEffect } from "react";
import "./ClaveModal.css";

/* ─── Icons ──────────────────────────────────────── */
const CopyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const ChevronDown = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const ZapIcon = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 384 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z" />
  </svg>
);

const LockIconPm = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const LockIconTgss = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    className="tgss-btn-lock-icon"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const CloseIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    className="tgss-close-icon"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const InfoCircleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    style={{ flexShrink: 0, marginTop: "1px" }}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const MobileIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12.01" y2="18" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1D9E75"
    strokeWidth="2.5"
  >
    <circle cx="12" cy="12" r="10" fill="#E1F5EE" stroke="none" />
    <polyline points="20 6 9 17 4 12" stroke="#1D9E75" strokeWidth="2.5" />
  </svg>
);

/* ─── Shared brand bar ───────────────────────────── */
const BrandBar = () => (
  <div className="pm-brand-bar">
    <span className="pm-brand-powered">Powered by</span>
    <div className="pm-brand-logo">
      <div className="pm-brand-icon">
        <svg width="11" height="6" viewBox="0 0 11 6" fill="none">
          <rect
            x="0"
            y="0"
            width="11"
            height="6"
            rx="3"
            fill="rgba(255,255,255,0.25)"
          />
          <circle cx="8" cy="3" r="2.5" fill="white" />
        </svg>
      </div>
      <span className="pm-brand-name">permisso</span>
    </div>
  </div>
);

/* ─── Progress Spinner ───────────────────────────── */
const Spinner = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    style={{ animation: "tgss-spin 0.8s linear infinite" }}
  >
    <circle cx="11" cy="11" r="9" stroke="#e0e0e0" strokeWidth="2.5" />
    <path
      d="M11 2a9 9 0 0 1 9 9"
      stroke="#1D9E75"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

const EmptyCircle = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <circle cx="11" cy="11" r="9" stroke="#d0d0d0" strokeWidth="2" />
  </svg>
);

/* ─── Data ───────────────────────────────────────── */
const permissoItems = [
  {
    title: "Declaración de la Renta en la Agencia Tributaria",
    description: `Datos personales identificativos y fiscales (incl. nombre completo, DNI y domicilio fiscal).
    Rendimientos del ejercicio anterior (incl. rendimientos del trabajo, capital mobiliario e inmobiliario, actividades económicas, entre otros). 
    Regímenes especiales de la Seg. Social y Convenios Especiales.`,
  },
  {
    title:
      "Pago fraccionado del IRPF en Estimación Directa (130) en la Agencia Tributaria",
    description: `Datos personales identificativos (incl. nombre completo y DNI).
    Actividades económicas en estimación directa, modalidad normal o simplificada. 
    Total liquidación.`,
  },
  {
    title: "Autoliquidación del IVA (303) en la Agencia Tributaria",
    description: `Datos personales identificativos (incl. nombre completo y DNI).
    Resumen de liquidaciones del IVA (bases imponibles y cuotas devengadas).
    Resultados de las liquidaciones.
    Datos bancarios asociados a la devolución.`,
  },
  {
    title: "Informe de Vida Laboral en la Seguridad Social",
    description: `Datos personales identificativos (incl. nombre completo, fecha de nacimiento, núm. de la Seg. Social, DNI y domicilio).
    Histórico de altas y bajas en la Seguridad Social (incl. fecha de alta y baja, tipo de régimen, tipo de contrato, tipo de jornada laboral, grupo y bases de cotización).
    Datos identificativos del empleador (incl. nombre o razón social y Código de Cuenta de Cotización). Resumen general de Vida Laboral.`,
  },
  {
    title: "Informe de Bases de Cotización en la Seguridad Social",
    description: `Datos personales identificativos (incl. nombre completo, fecha de nacimiento, núm. de la Seg. Social, DNI y domicilio).
    Listado de las bases de cotización resultantes mes a mes por empleador y/o régimen.
    Datos identificativos del empleador (incl. nombre o razón social y Código de Cuenta de Cotización).`,
  },
];

const securityFeatures = [
  {
    icon: <ZapIcon />,
    title: "Conecte automáticamente y sin esfuerzo",
    desc: "Conecte todos sus documentos y datos en cuestión de minutos, 100% online y sin necesidad de evitar la burocracia con las Administraciones Públicas.",
  },
  {
    icon: <EyeOffIcon />,
    title: "Sus datos bajo su control absoluto",
    desc: "Sus datos son suyos y usted decide a quién le da acceso y a quién se lo quita en todo momento.",
  },
  {
    icon: <LockIconPm />,
    title: "Seguridad y privacidad por encima de todo",
    desc: "Todas las conexiones con las Administraciones Públicas así como todas las transferencias de información se realizan de manera segura y encriptada y bajo los mayores protocolos de seguridad del mercado.",
  },
];

/* ─── Step 4: TGSS Progress items ───────────────── */
const TGSS_PROGRESS_ITEMS = [
  "Obtención del informe de la Vida Laboral",
  "Obtención del Informe de Bases de Cotización",
];

/* ─── Step 5: Agencia Tributaria Progress items ─── */
const AEAT_PROGRESS_ITEMS = ["Obtención de la Declaración de la Renta"];

const PIN_LENGTH = 6;

/* ─── Progress Row ───────────────────────────────── */
const ProgressRow = ({ label, status }) => (
  <div className="progress-row">
    <div className="progress-row-icon">
      {status === "loading" && <Spinner />}
      {status === "done" && <CheckCircleIcon />}
      {status === "pending" && <EmptyCircle />}
    </div>
    <span className="progress-row-label">{label}</span>
    <span className={`progress-row-status progress-row-status--${status}`}>
      {status === "loading" && "Cargando..."}
      {status === "done" && "Completado"}
      {status === "pending" && "Pendiente"}
    </span>
  </div>
);

/* ─── Component ──────────────────────────────────── */
export default function ClaveModal({ handleSubmit, onClose }) {
  const [step, setStep] = useState("permisos-modal");

  const overlayClass =
    "pm-wrapper popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen";

  /* ── Step 1 state ── */
  const [activeTab, setActiveTab] = useState("permisos");
  const [openItems, setOpenItems] = useState({});
  const [openCopy, setOpenCopy] = useState(false);
  const [checked, setChecked] = useState(false);

  const toggleItem = (i) =>
    setOpenItems((prev) => ({ ...prev, [i]: !prev[i] }));

  const handleSiguiente = () => {
    if (!checked) return;
    setStep("tgss-modal");
  };

  /* ── Step 2 state ── */
  const [dni, setDni] = useState("");
  const [fecha, setFecha] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const isFormValid = dni.trim() !== "" && fecha !== "";

  const handleConectar = () => {
    if (!isFormValid || btnLoading) return;
    setBtnLoading(true);
    setTimeout(() => {
      setBtnLoading(false);
      setStep("pin-modal");
    }, 1000);
  };

  /* ── Step 3 state ── */
  const [pin, setPin] = useState(Array(PIN_LENGTH).fill(""));
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [countdown, setCountdown] = useState(18);
  const pinRefs = useRef([]);
  const countdownRef = useRef(null);

  useEffect(() => {
    if (step !== "pin-modal") return;
    setCountdown(18);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdownRef.current);
  }, [step]);

  const isPinComplete = pin.every((d) => d !== "");

  const handlePinChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const next = [...pin];
    next[index] = value.slice(-1);
    setPin(next);
    if (value && index < PIN_LENGTH - 1) pinRefs.current[index + 1]?.focus();
  };

  const handlePinKeyDown = (index, e) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      pinRefs.current[index - 1]?.focus();
    }
  };

  const handlePinPaste = (e) => {
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, PIN_LENGTH);
    if (!pasted) return;
    e.preventDefault();
    const next = Array(PIN_LENGTH).fill("");
    pasted.split("").forEach((ch, i) => {
      next[i] = ch;
    });
    setPin(next);
    pinRefs.current[Math.min(pasted.length, PIN_LENGTH - 1)]?.focus();
  };

  const handleConfirmar = () => {
    if (!isPinComplete || confirmLoading) return;
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmLoading(false);
      setStep("tgss-progress");
    }, 2000);
  };

  const formatCountdown = (s) =>
    `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  /* ── Step 4: TGSS Progress state ── */
  const [tgssStatuses, setTgssStatuses] = useState(
    TGSS_PROGRESS_ITEMS.map(() => "pending")
  );

  useEffect(() => {
    if (step !== "tgss-progress") return;
    setTgssStatuses(TGSS_PROGRESS_ITEMS.map(() => "pending"));
    let i = 0;
    const runNext = () => {
      if (i >= TGSS_PROGRESS_ITEMS.length) {
        // All done — go back to pin-modal (step 3) automatically
        setTimeout(() => {
          setPin(Array(PIN_LENGTH).fill(""));
          setStep("pin-modal");
        }, 600);
        return;
      }
      const idx = i;
      setTgssStatuses((prev) => {
        const next = [...prev];
        next[idx] = "loading";
        return next;
      });
      setTimeout(() => {
        setTgssStatuses((prev) => {
          const next = [...prev];
          next[idx] = "done";
          return next;
        });
        i++;
        setTimeout(runNext, 200);
      }, 2000);
    };
    const t = setTimeout(runNext, 300);
    return () => clearTimeout(t);
  }, [step]);

  /* ── Step 5: AEAT Progress state ── */
  const [aeatStatuses, setAeatStatuses] = useState(
    AEAT_PROGRESS_ITEMS.map(() => "pending")
  );

  useEffect(() => {
    if (step !== "aeat-progress") return;
    setAeatStatuses(AEAT_PROGRESS_ITEMS.map(() => "pending"));
    let i = 0;
    const runNext = () => {
      if (i >= AEAT_PROGRESS_ITEMS.length) {
        // All done — close modal
        setTimeout(() => {
          handleSubmit();
          onClose && onClose("success");
        }, 600);
        return;
      }
      const idx = i;
      setAeatStatuses((prev) => {
        const next = [...prev];
        next[idx] = "loading";
        return next;
      });
      setTimeout(() => {
        setAeatStatuses((prev) => {
          const next = [...prev];
          next[idx] = "done";
          return next;
        });
        i++;
        setTimeout(runNext, 200);
      }, 2000);
    };
    const t = setTimeout(runNext, 300);
    return () => clearTimeout(t);
  }, [step]);

  /* ── Second PIN confirm (goes to aeat-progress) ── */
  const [pin2, setPin2] = useState(Array(PIN_LENGTH).fill(""));
  const [confirm2Loading, setConfirm2Loading] = useState(false);
  const [countdown2, setCountdown2] = useState(18);
  const pin2Refs = useRef([]);
  const countdown2Ref = useRef(null);

  useEffect(() => {
    if (step !== "pin-modal") return;
    // Determine which confirm handler to use based on whether tgss is done
    setCountdown2(18);
    countdown2Ref.current = setInterval(() => {
      setCountdown2((prev) => {
        if (prev <= 1) {
          clearInterval(countdown2Ref.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdown2Ref.current);
  }, [step]);

  /* ── Track whether we've done TGSS progress already ── */
  const tgssProgressDone = tgssStatuses.every((s) => s === "done");

  const handlePinChange2 = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const next = [...pin2];
    next[index] = value.slice(-1);
    setPin2(next);
    if (value && index < PIN_LENGTH - 1) pin2Refs.current[index + 1]?.focus();
  };

  const handlePinKeyDown2 = (index, e) => {
    if (e.key === "Backspace" && !pin2[index] && index > 0) {
      pin2Refs.current[index - 1]?.focus();
    }
  };

  const handlePinPaste2 = (e) => {
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, PIN_LENGTH);
    if (!pasted) return;
    e.preventDefault();
    const next = Array(PIN_LENGTH).fill("");
    pasted.split("").forEach((ch, i) => {
      next[i] = ch;
    });
    setPin2(next);
    pin2Refs.current[Math.min(pasted.length, PIN_LENGTH - 1)]?.focus();
  };

  const isPinComplete2 = pin2.every((d) => d !== "");

  const handleConfirmar2 = () => {
    if (!isPinComplete2 || confirm2Loading) return;
    setConfirm2Loading(true);
    setTimeout(() => {
      setConfirm2Loading(false);
      setStep("aeat-progress");
    }, 2000);
  };

  /* ════════ RENDER ════════ */

  /* Step 1 */
  if (step === "permisos-modal") {
    return (
      <div className={overlayClass}>
        <div className="pm-card">
          <div className="pm-header position-relative">
            <button
              className="tgss-close-btn"
              onClick={() => onClose && onClose("cancel")}
              aria-label="Cerrar"
            >
              <CloseIcon />
            </button>
            <div className="pm-logos">
              <div className="pm-logos-inner">
                <div className="pm-logo-skor">
                  <img src="/images/skor-logo.png" alt="Skor" />
                </div>
                <div className="pm-logo-permisso">
                  <svg width="28" height="14" viewBox="0 0 28 14" fill="none">
                    <rect
                      x="0"
                      y="0"
                      width="28"
                      height="14"
                      rx="7"
                      fill="rgba(255,255,255,0.25)"
                    />
                    <circle cx="21" cy="7" r="6" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            <h2 className="pm-title">
              <strong>Skor</strong> utiliza <strong>Permisso</strong> para
              conectar sus datos
            </h2>
            <div className="pm-tabs">
              {[
                { key: "permisos", label: "Permisos" },
                { key: "seguridad", label: "Seguridad y otros" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  className={`pm-tab${activeTab === tab.key ? " active" : ""}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="pm-content">
            {activeTab === "permisos" ? (
              <>
                <p className="pm-section-label">
                  Se accederán a el/los{" "}
                  <strong>siguiente(s) documento(s) y datos:</strong>
                </p>
                <div className="pm-accordion-list">
                  {permissoItems.map((item, i) => (
                    <div key={i}>
                      <button
                        className={`pm-accordion-btn${openItems[i] ? " open" : ""}`}
                        onClick={() => toggleItem(i)}
                      >
                        <div className="pm-accordion-btn-inner">
                          <span className="pm-accordion-icon">
                            <img src="/images/docIconGreen.svg" alt="File" />
                          </span>
                          <span className="pm-accordion-label">
                            {item.title}
                          </span>
                        </div>
                        <span
                          className={`pm-accordion-chevron${openItems[i] ? " open" : ""}`}
                        >
                          <ChevronDown />
                        </span>
                      </button>
                      {openItems[i] && (
                        <div className="pm-accordion-body">
                          {item.description}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <p className="pm-usted-label">
                  <strong>Usted</strong> podrá:
                </p>
                <div>
                  <button
                    className={`pm-accordion-btn${openCopy ? " open" : ""}`}
                    onClick={() => setOpenCopy(!openCopy)}
                  >
                    <div className="pm-accordion-btn-inner">
                      <span className="pm-accordion-icon">
                        <CopyIcon />
                      </span>
                      <span className="pm-accordion-label">
                        Obtener una copia de cada documento
                      </span>
                    </div>
                    <span
                      className={`pm-accordion-chevron${openCopy ? " open" : ""}`}
                    >
                      <ChevronDown />
                    </span>
                  </button>
                  {openCopy && (
                    <div className="pm-accordion-body">
                      Al finalizar el proceso, podrá descargar una copia de cada
                      documento consultado, generado, o un comprobante que
                      acredite que la solicitud fue realizada con éxito.
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="pm-security-list">
                {securityFeatures.map((feature, i) => (
                  <div key={i} className="pm-security-item">
                    <div className="pm-security-icon">{feature.icon}</div>
                    <div>
                      <p className="pm-security-title">{feature.title}</p>
                      <p className="pm-security-desc">{feature.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="pm-footer">
            <label className="pm-checkbox-label">
              <input
                type="checkbox"
                className="pm-checkbox"
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
              <span className="pm-checkbox-text">
                Acepto la <a href="#">Política de Privacidad</a>, así como los{" "}
                <a href="#">Términos y Condiciones</a>, y concedo permiso para
                mantener un registro de consentimientos.
              </span>
            </label>
            <div className="pm-siguiente-wrap">
              <button
                className={`pm-siguiente-btn${checked ? " enabled" : ""}`}
                onClick={handleSiguiente}
              >
                Siguiente
              </button>
            </div>
          </div>

          <BrandBar />
        </div>
      </div>
    );
  }

  /* Step 2 */
  if (step === "tgss-modal") {
    return (
      <div className={overlayClass}>
        <div className="tgss-card">
          <div className="tgss-card-body">
            <button
              className="tgss-close-btn"
              onClick={() => onClose && onClose("cancel")}
              aria-label="Cerrar"
            >
              <CloseIcon />
            </button>

            <h2 className="tgss-title">
              Conexión con la Seguridad Social (TGSS)
            </h2>
            <p className="tgss-subtitle">
              Introduzca o verifique sus datos y siga los pasos para completar
              la conexión
            </p>

            <div className="tgss-fields">
              <div className="tgss-field-group">
                <label className="tgss-label">
                  DNI/NIE<span className="tgss-required">*</span>
                </label>
                <input
                  className="tgss-input"
                  type="text"
                  placeholder="12345678A"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                  maxLength={9}
                />
              </div>
              <div className="tgss-field-group">
                <label className="tgss-label">
                  Fecha de Validez (o Expedición si es un DNI Permanente)
                  <span className="tgss-required">*</span>
                </label>
                <input
                  className="tgss-input"
                  type="date"
                  value={fecha}
                  onChange={(e) => setFecha(e.target.value)}
                />
              </div>
            </div>

            <div className="tgss-btn-wrap">
              <button
                className={`tgss-btn${isFormValid ? " enabled" : ""}${btnLoading ? " loading" : ""}`}
                onClick={handleConectar}
                disabled={!isFormValid || btnLoading}
              >
                {btnLoading ? (
                  <span className="tgss-btn-spinner" />
                ) : (
                  <LockIconTgss />
                )}
                <span>Conectar</span>
              </button>
            </div>
          </div>
          <BrandBar />
        </div>
      </div>
    );
  }

  /* Step 3 — PIN (first time: leads to tgss-progress) */
  if (step === "pin-modal" && !tgssProgressDone) {
    return (
      <div className={overlayClass}>
        <div className="tgss-card">
          <div className="tgss-card-body">
            <button
              className="tgss-close-btn"
              onClick={() => onClose && onClose("cancel")}
              aria-label="Cerrar"
            >
              <CloseIcon />
            </button>

            <h2 className="tgss-title">
              Conexión con la Seguridad Social (TGSS)
            </h2>
            <p className="tgss-subtitle">
              Introduzca el código PIN que le ha llegado por{" "}
              <strong>SMS al móvil acabado en ****71462</strong>
            </p>

            <label
              className="tgss-label"
              style={{ display: "block", marginBottom: "1vw" }}
            >
              Introduzca el PIN<span className="tgss-required">*</span>
            </label>

            <div className="pin-boxes" onPaste={handlePinPaste}>
              {pin.map((digit, i) => (
                <input
                  key={i}
                  ref={(el) => (pinRefs.current[i] = el)}
                  className={`pin-box${digit ? " filled" : ""}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handlePinChange(i, e.target.value)}
                  onKeyDown={(e) => handlePinKeyDown(i, e)}
                />
              ))}
            </div>

            <div className="pin-info-banner">
              <div className="pin-info-top">
                <InfoCircleIcon />
                <span>
                  ¿No le ha llegado el código PIN? Puede volver a solicitar el
                  código en <strong>{formatCountdown(countdown)}</strong>
                </span>
              </div>
              <div className="pin-info-bottom">
                <span className="pin-info-via">Conectar vía</span>
                <div className="pin-mobile-btn">
                  <MobileIcon />
                  <span>Móvil</span>
                </div>
              </div>
            </div>

            <div className="tgss-btn-wrap pin-confirm-wrap">
              <button
                className={`tgss-btn pin-confirm-btn${isPinComplete ? " enabled" : ""}${confirmLoading ? " loading" : ""}`}
                onClick={handleConfirmar}
                disabled={!isPinComplete || confirmLoading}
              >
                {confirmLoading && <span className="tgss-btn-spinner" />}
                <span>Confirmar</span>
              </button>
            </div>
          </div>

          <BrandBar />
        </div>
      </div>
    );
  }

  /* Step 4 — TGSS Progress */
  if (step === "tgss-progress") {
    return (
      <div className={overlayClass}>
        <div className="tgss-card">
          <div className="tgss-card-body">
            <h2 className="tgss-title">
              Conexión con la Seguridad Social (TGSS)
            </h2>
            <p className="tgss-subtitle">
              {tgssStatuses.every((s) => s === "done")
                ? "Documentos obtenidos con éxito."
                : "Obteniendo sus documentos, por favor espere..."}
            </p>

            <div className="progress-list">
              {TGSS_PROGRESS_ITEMS.map((label, i) => (
                <ProgressRow key={i} label={label} status={tgssStatuses[i]} />
              ))}
            </div>
          </div>
          <BrandBar />
        </div>
      </div>
    );
  }

  /* Step 3 (second time) — PIN after TGSS progress, leads to aeat-progress */
  if (step === "pin-modal" && tgssProgressDone) {
    return (
      <div className={overlayClass}>
        <div className="tgss-card">
          <div className="tgss-card-body">
            <button
              className="tgss-close-btn"
              onClick={() => onClose && onClose("cancel")}
              aria-label="Cerrar"
            >
              <CloseIcon />
            </button>

            <h2 className="tgss-title">
              Conexión con la Seguridad Social (TGSS)
            </h2>
            <p className="tgss-subtitle">
              Introduzca el código PIN que le ha llegado por{" "}
              <strong>SMS al móvil acabado en ****71462</strong>
            </p>

            <label
              className="tgss-label"
              style={{ display: "block", marginBottom: "1vw" }}
            >
              Introduzca el PIN<span className="tgss-required">*</span>
            </label>

            <div className="pin-boxes" onPaste={handlePinPaste2}>
              {pin2.map((digit, i) => (
                <input
                  key={i}
                  ref={(el) => (pin2Refs.current[i] = el)}
                  className={`pin-box${digit ? " filled" : ""}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handlePinChange2(i, e.target.value)}
                  onKeyDown={(e) => handlePinKeyDown2(i, e)}
                />
              ))}
            </div>

            <div className="pin-info-banner">
              <div className="pin-info-top">
                <InfoCircleIcon />
                <span>
                  ¿No le ha llegado el código PIN? Puede volver a solicitar el
                  código en <strong>{formatCountdown(countdown2)}</strong>
                </span>
              </div>
              <div className="pin-info-bottom">
                <span className="pin-info-via">Conectar vía</span>
                <div className="pin-mobile-btn">
                  <MobileIcon />
                  <span>Móvil</span>
                </div>
              </div>
            </div>

            <div className="tgss-btn-wrap pin-confirm-wrap">
              <button
                className={`tgss-btn pin-confirm-btn${isPinComplete2 ? " enabled" : ""}${confirm2Loading ? " loading" : ""}`}
                onClick={handleConfirmar2}
                disabled={!isPinComplete2 || confirm2Loading}
              >
                {confirm2Loading && <span className="tgss-btn-spinner" />}
                <span>Confirmar</span>
              </button>
            </div>
          </div>

          <BrandBar />
        </div>
      </div>
    );
  }

  /* Step 5 — AEAT Progress */
  if (step === "aeat-progress") {
    return (
      <div className={overlayClass}>
        <div className="tgss-card">
          <div className="tgss-card-body">
            <h2 className="tgss-title">Conexión con Hacienda</h2>
            <p className="tgss-subtitle">
              {aeatStatuses.every((s) => s === "done")
                ? "Todos los documentos obtenidos con éxito."
                : "Obteniendo sus documentos, por favor espere..."}
            </p>

            <div className="progress-list">
              {AEAT_PROGRESS_ITEMS.map((label, i) => (
                <ProgressRow key={i} label={label} status={aeatStatuses[i]} />
              ))}
            </div>
          </div>
          <BrandBar />
        </div>
      </div>
    );
  }

  return null;
}
